export default "__VITE_ASSET__e007b2df__"